import React from 'react';

const NewTag = ({
  className,
  text,
  color = 'green',
}: {
  className?: string;
  text?: string;
  color?: 'green' | 'orange';
}) => {
  return (
    <div
      className={`inline-block relative z-0 -top-1.5 left-0.5 tablet:left-0 h-3 box-border rounded-xs px-1 py-px text-[9px] font-semibold leading-[9px] font-sans! text-white ${
        color === 'orange' ? 'bg-wren-orange' : 'bg-wren-green'
      }${className ? ` ${className}` : ''}`}
    >
      {text ?? 'New'}
    </div>
  );
};

export default NewTag;
